import { AnimatePresence } from 'framer-motion';
import { useRescheduleContext } from '../../../contexts/RescheduleProvider';
import { AppointmentHistory } from '../../../types/history';
import AppointmentHistoryDetailsModal from '../../CommonComps/Modals/AppointmentHistoryDetailsModal';
import RescheduleAppointmentModal from '../../CommonComps/Modals/RescheduleAppointmentModal';

const RescheduleModalWrapper = () => {
  // integration of context hooks here
  const {
    showRescheduleModal,
    showDetailsModal,
    isAssociate,
    appointment,
    setShowRescheduleModal,
    setShowDetailsModal,
  } = useRescheduleContext();

  // rendering reschedule modal wrapper component here
  return (
    <>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showRescheduleModal && (
          <RescheduleAppointmentModal
            handleModalClose={() => setShowRescheduleModal(false)}
            appointment={appointment as AppointmentHistory}
          />
        )}
      </AnimatePresence>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showDetailsModal && (
          <AppointmentHistoryDetailsModal
            handleModalClose={() => setShowDetailsModal(false)}
            isAssociate={isAssociate}
            appointment={appointment as AppointmentHistory}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default RescheduleModalWrapper;
